module.exports = __webpack_public_path__ + "img/30.8e9c01b1.jpg";